import recruiter from "@/assets/images/agents/recruiter.png";
import employeeGuardian from "@/assets/images/agents/employee-guardian.png";
import campaignSpecialist from "@/assets/images/agents/campaign-specialist.png";
import salesAdvisor from "@/assets/images/agents/sales-advisor.png";
import receptionist from "@/assets/images/agents/receptionist.png";
import medicalRegistrar from "@/assets/images/agents/medical-registrar.png";
import salesperson from "@/assets/images/agents/salesperson.png";
import tenderSpecialist from "@/assets/images/agents/tender-specialist.png";

// Light centre fading to a saturated edge, like the tiles on cyberjob.ai.
const radial = (light, edge) => `radial-gradient(circle at 50% 55%, ${light} 0%, ${edge} 100%)`;

// `type` matches the backend AgentType; only agents that exist as a product line have one.
// Everything else is "coming soon" and has no backing agent yet.
export const AGENT_CATALOG = [
    { key: "recruiter", type: "Recruiter", image: recruiter, tile: radial("#FDBA74", "#EA580C"), dashboard: "/recruitment" },
    { key: "salesperson", type: "SalesManager", image: salesperson, tile: radial("#FCD34D", "#D97706"), dashboard: "/sales" },
    { key: "employeeGuardian", type: null, image: employeeGuardian, tile: radial("#86EFAC", "#16A34A") },
    { key: "campaignSpecialist", type: null, image: campaignSpecialist, tile: radial("#93C5FD", "#2563EB") },
    { key: "salesAdvisor", type: null, image: salesAdvisor, tile: radial("#FDA4AF", "#E11D48") },
    { key: "receptionist", type: null, image: receptionist, tile: radial("#C4B5FD", "#7C3AED") },
    { key: "medicalRegistrar", type: null, image: medicalRegistrar, tile: radial("#5EEAD4", "#0D9488") },
    { key: "tenderSpecialist", type: null, image: tenderSpecialist, tile: radial("#FCA5A5", "#DC2626") },
];

// Tile colours for the 2nd, 3rd... agent of the same type, so several agents of one kind stay
// visually distinguishable. The first one keeps the type's own colour.
const TILE_VARIANTS = [
    radial("#86EFAC", "#16A34A"),
    radial("#93C5FD", "#2563EB"),
    radial("#C4B5FD", "#7C3AED"),
    radial("#FDA4AF", "#E11D48"),
    radial("#5EEAD4", "#0D9488"),
    radial("#FCA5A5", "#DC2626"),
];

export const tileForDuplicate = (entry, indexAmongSameType) =>
    indexAmongSameType === 0 ? entry.tile : TILE_VARIANTS[(indexAmongSameType - 1) % TILE_VARIANTS.length];

export const catalogEntryForType = (type) => AGENT_CATALOG.find((entry) => entry.type === (type ?? "Recruiter"));
